export const isLocal: boolean = process.env.NEXT_PUBLIC_ENV === 'local'
export const isStaging: boolean = process.env.NEXT_PUBLIC_ENV === 'staging'
export const isSandbox: boolean = process.env.NEXT_PUBLIC_ENV === 'sandbox'
export const isProduction: boolean = process.env.NEXT_PUBLIC_ENV === 'production'
export const isSquad: boolean = process.env.NEXT_PUBLIC_ENV === 'squad'
export const isTest: boolean = process.env.NEXT_PUBLIC_ENV === 'test'
